// src/lib/legalContent.js
// 法務3ページの本文。★ 事業者情報を変えるのは BIZ の1箇所だけ。

// ============================================================
// 🔴 要記入：公開前に必ず埋めること
// ============================================================
export const BIZ = {
  name: 'Digital商店',
  owner: '松本 翔汰',
  address: '761-8044 香川県高松市円座町1040-7',           // 🔴 特商法上、原則省略不可
  tel: '080-6605-9504',              // 🔴 特商法上、原則省略不可
  telHours: '平日 10:00〜18:00（土日祝・年末年始を除く）',
  email: 'Digital.shoten@gmail.com',      // 🔴
  qualifiedNo: 'T1810128485030',
  url: 'https://totonoee.vercel.app',
  effectiveDate: '2026年7月15日',      // 🔴 例：2026年8月1日
  court: '高松地方裁判所',
  price: '980円（消費税込）',
};

// ============================================================
// 内部ヘルパー（本文の型）
// section: { h: '見出し', body: [...] }
// body の要素:
//   文字列          → 段落
//   { ul: [...] }   → 箇条書き
//   { ol: [...] }   → 番号付き
//   { table: { head: [...], rows: [[...]] } } → 表
//   { note: '...' } → 注意ボックス
// ============================================================

// ------------------------------------------------------------
// 特定商取引法に基づく表記
// ------------------------------------------------------------
const tokushoho = {
  title: '特定商取引法に基づく表記',
  updated: BIZ.effectiveDate,
  sections: [
    {
      h: null,
      body: [
        {
          table: {
            head: ['項目', '内容'],
            rows: [
              ['サービス名', 'Totonoee（トトノエ）'],
              ['販売事業者', BIZ.name],
              ['運営統括責任者', BIZ.owner],
              ['所在地', BIZ.address],
              ['電話番号', `${BIZ.tel}\n受付時間：${BIZ.telHours}`],
              ['メールアドレス', BIZ.email],
              ['適格請求書発行事業者登録番号', BIZ.qualifiedNo],
              ['ホームページURL', BIZ.url],
            ],
          },
        },
      ],
    },
    {
      h: '販売価格',
      body: [
        {
          table: {
            head: ['プラン', '月額料金'],
            rows: [
              ['Free', '無料'],
              ['Pro', BIZ.price + ' ／ 月'],
            ],
          },
        },
        '表示価格はすべて消費税込みです。',
      ],
    },
    {
      h: '商品代金以外に必要な料金',
      body: [
        {
          ul: [
            'インターネット接続に必要な通信料金（お客様のご負担となります）',
            '金融機関やクレジットカード会社が定める手数料が発生する場合があります',
          ],
        },
      ],
    },
    {
      h: '支払方法',
      body: [
        'クレジットカード決済（Visa / Mastercard / American Express / JCB など）',
        '決済処理は Stripe, Inc. が提供する決済システムを利用します。当社はお客様のクレジットカード番号を保持しません。',
      ],
    },
    {
      h: '支払時期',
      body: [
        {
          ul: [
            '初回：お申し込み手続きの完了時に即時決済されます',
            '2回目以降：初回決済日を起算日として、毎月同日に自動的に決済されます（該当日が存在しない月は、その月の末日）',
          ],
        },
      ],
    },
    {
      h: 'サービスの提供時期',
      body: ['決済完了後、ただちにProプランの全機能をご利用いただけます。'],
    },
    {
      h: '解約について',
      body: [
        {
          ul: [
            '「プロフィール設定」→「プラン」→「お支払い管理」からいつでも解約できます',
            '解約手続き後も、すでにお支払いいただいた期間の終了日まではProプランをご利用いただけます',
            '期間終了日をもって自動的にFreeプランへ移行し、以降の請求は発生しません',
          ],
        },
      ],
    },
    {
      h: '返品・返金について',
      body: [
        '本サービスはデジタルコンテンツの性質上、決済完了後の返金・キャンセルはお受けしておりません。',
        'ただし、以下の場合はこの限りではありません。',
        {
          ul: [
            '当社の責めに帰すべき事由により、本サービスが継続して利用できない状態が生じた場合',
            '二重決済など、当社のシステム上の誤りにより誤った請求が行われた場合',
          ],
        },
        `上記に該当する場合は、${BIZ.email} までご連絡ください。個別に対応いたします。`,
      ],
    },
    {
      h: '解約後のデータの取り扱い',
      body: [
        'Freeプランへ移行した場合も、登録済みのデータは削除されません。',
        'ただし、Freeプランの制限（案件数の上限など）を超えているデータについては、閲覧はできますが新規の追加ができなくなります。データそのものが失われることはありません。',
      ],
    },
    {
      h: '動作環境',
      body: [
        {
          ul: [
            '最新版の Google Chrome / Safari / Microsoft Edge / Firefox',
            'インターネット接続環境',
          ],
        },
      ],
    },
  ],
};

// ------------------------------------------------------------
// 利用規約
// ------------------------------------------------------------
const terms = {
  title: '利用規約',
  updated: BIZ.effectiveDate,
  intro: `この利用規約（以下「本規約」）は、${BIZ.name}（以下「当社」）が提供するサービス「Totonoee」および「Totonoee Manager」（以下あわせて「本サービス」）の利用条件を定めるものです。ご利用のお客様（以下「ユーザー」）は、本規約に同意のうえ本サービスをご利用ください。`,
  sections: [
    {
      h: '第1条（適用）',
      body: [
        {
          ol: [
            '本規約は、ユーザーと当社との間の本サービスの利用に関する一切の関係に適用されます。',
            '当社が本サービス上で掲載する個別の規定・ガイドラインは、本規約の一部を構成します。',
            '本規約の内容と個別規定の内容が異なる場合は、個別規定が優先します。',
          ],
        },
      ],
    },
    {
      h: '第2条（定義）',
      body: [
        {
          table: {
            head: ['用語', '定義'],
            rows: [
              ['Totonoee', 'フリーランス・個人事業主向けの案件・請求・経費管理サービス'],
              ['Totonoee Manager', '発注者が、承認を得たパートナーの情報を閲覧・依頼するための管理者向けサービス'],
              ['フリーランサー', 'Totonoeeを利用するユーザー'],
              ['管理者', 'Totonoee Managerを利用するユーザー'],
              ['登録情報', 'ユーザーが本サービスに入力・保存した一切のデータ'],
              ['Proプラン', '有料の利用プラン'],
              ['Freeプラン', '無料の利用プラン'],
            ],
          },
        },
      ],
    },
    {
      h: '第3条（利用登録）',
      body: [
        '本サービスの利用を希望する者は、当社の定める方法により利用登録を申請し、当社がこれを承認することで利用登録が完了します。',
        '当社は、以下のいずれかに該当すると判断した場合、利用登録を承認しないことがあります。理由の開示義務は負いません。',
        {
          ol: [
            '登録事項に虚偽の記載があった場合',
            '過去に本規約に違反したことがある者からの申請である場合',
            '反社会的勢力等に該当し、または関与していると当社が判断した場合',
            'その他、当社が利用登録を相当でないと判断した場合',
          ],
        },
      ],
    },
    {
      h: '第4条（アカウントの管理）',
      body: [
        {
          ol: [
            'ユーザーは、自己の責任においてアカウント情報（メールアドレス・パスワード）を管理するものとします。',
            'アカウント情報の管理不十分、第三者の使用、盗用等による損害の責任はユーザーが負い、当社は責任を負いません。',
            'アカウントの第三者への譲渡・貸与・共有はできません。',
          ],
        },
      ],
    },
    {
      h: '第5条（料金および支払方法）',
      body: [
        {
          ol: [
            '本サービスにはFreeプランとProプランがあります。各プランの機能と制限は、本サービス上に表示するとおりです。',
            `Proプランの利用料金は月額${BIZ.price}です。`,
            '利用料金は、当社が指定するクレジットカード決済（Stripe, Inc.が提供する決済システム）によりお支払いいただきます。',
            '利用料金は、初回申込時に即時決済され、以後は初回決済日を起算日として毎月自動的に決済されます。',
            'ユーザーが利用料金の支払いを遅滞した場合、当社はProプランの提供を停止することができます。',
          ],
        },
      ],
    },
    {
      h: '第6条（Proプランの解約）',
      body: [
        {
          ol: [
            'ユーザーは、本サービス内の「お支払い管理」からいつでもProプランを解約できます。',
            '解約後も、すでに支払済みの期間の終了日まではProプランを利用できます。期間終了日をもってFreeプランへ移行します。',
            '日割りによる返金は行いません。',
            'Freeプランへ移行した場合も、登録情報は削除されません。ただしFreeプランの制限を超える範囲での新規登録はできなくなります。',
          ],
        },
      ],
    },
    {
      h: '第7条（無償提供・特典）',
      body: [
        {
          ol: [
            '当社は、初期からご利用いただいているユーザーその他当社が定める条件を満たすユーザーに対し、Proプランの機能を無償で提供することがあります。',
            '前項の特典は、当社の裁量により提供されるものであり、その内容・条件・提供期間は当社が定めます。',
            '当社は、ユーザーが本規約に違反した場合、前項の特典を取り消すことができます。',
          ],
        },
      ],
    },
    {
      h: '第8条（AI機能の利用）',
      body: [
        {
          ol: [
            '本サービスは、見積もりの提案、請求メールの生成、収支に関する助言等の機能（以下「AI機能」）を提供します。',
            'AI機能は Anthropic PBC（米国）が提供する大規模言語モデルAPIを利用しており、AI機能の利用時には、ユーザーが入力・保存した情報の一部（案件名・金額・クライアント名・収支データ等）が同社のサーバー（米国）に送信されます。詳細はプライバシーポリシーをご確認ください。',
            'AI機能の出力は参考情報にすぎず、その正確性・完全性・有用性を当社は保証しません。特に、金額の見積もり、税務・会計・法務に関する内容は、必ずユーザー自身の判断および専門家への確認を経てご利用ください。',
            'AI機能の出力に依拠してユーザーが行った判断・行為の結果について、当社は一切の責任を負いません。',
            '当社は、AI機能の利用回数に制限を設けることができます。',
          ],
        },
      ],
    },
    {
      h: '第9条（Totonoee Manager との連携）',
      body: [
        {
          ol: [
            '管理者は、フリーランサーに対して連携の招待を送ることができます。',
            '連携は、フリーランサー本人が承認した場合にのみ成立します。承認がない限り、管理者はフリーランサーの情報を閲覧できません。',
            '案件情報は、初期状態では管理者に公開されません。フリーランサーが案件ごとに公開設定を行った場合にのみ、当該案件が管理者に表示されます。',
            'フリーランサーは、いつでも公開設定を解除し、または連携を解除することができます。',
            '管理者は、閲覧した情報を、本サービスの利用目的の範囲を超えて利用してはなりません。',
          ],
        },
      ],
    },
    {
      h: '第10条（データのバックアップ）',
      body: [
        {
          ol: [
            'ユーザーは、自己の責任において登録情報のバックアップを行うものとします。',
            '当社は、システム障害・不具合その他の事由により登録情報が消失した場合において、その復旧を保証しません。',
          ],
        },
      ],
    },
    {
      h: '第11条（禁止事項）',
      body: [
        'ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。',
        {
          ol: [
            '法令または公序良俗に違反する行為',
            '犯罪行為に関連する行為',
            '当社、他のユーザー、その他の第三者の知的財産権・肖像権・プライバシー・名誉その他の権利または利益を侵害する行為',
            '本サービスのサーバーまたはネットワークの機能を破壊・妨害する行為',
            '本サービスを、リバースエンジニアリング、逆コンパイル、逆アセンブルする行為',
            '本サービスの脆弱性を利用し、または利用しようと試みる行為',
            '当社の許可なく、本サービスを自動化された手段（ボット・スクレイパー等）により利用する行為',
            '本サービスの利用制限（案件数の上限、機能制限等）を、技術的手段により回避する行為',
            '虚偽の情報を登録する行為',
            '他のユーザーのアカウントを利用する行為',
            '反社会的勢力等に対して直接または間接に利益を供与する行為',
            'その他、当社が不適切と判断する行為',
          ],
        },
      ],
    },
    {
      h: '第12条（本サービスの提供の停止等）',
      body: [
        '当社は、以下のいずれかの事由があると判断した場合、事前の通知なく本サービスの全部または一部の提供を停止・中断することができます。',
        {
          ol: [
            '本サービスにかかるシステムの保守点検・更新を行う場合',
            '地震・落雷・火災・停電・天災等の不可抗力により提供が困難となった場合',
            'コンピュータまたは通信回線等が事故により停止した場合',
            '当社が利用する外部サービス（Supabase、Vercel、Stripe、Anthropic等）に障害が生じた場合',
            'その他、当社が停止・中断を必要と判断した場合',
          ],
        },
        '当社は、前項による本サービスの停止・中断によりユーザーに生じた損害について、一切の責任を負いません。',
      ],
    },
    {
      h: '第13条（利用制限および登録抹消）',
      body: [
        '当社は、ユーザーが以下のいずれかに該当する場合、事前の通知なく、当該ユーザーについて本サービスの利用を制限し、または利用登録を抹消することができます。',
        {
          ol: [
            '本規約のいずれかの条項に違反した場合',
            '登録事項に虚偽の事実があることが判明した場合',
            '料金の支払いを遅滞した場合',
            '当社からの連絡に対し、30日間以上応答がない場合',
            'その他、当社が本サービスの利用を適当でないと判断した場合',
          ],
        },
        '当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。',
      ],
    },
    {
      h: '第14条（退会）',
      body: [
        {
          ol: [
            'ユーザーは、当社の定める方法により、いつでも退会できます。',
            '退会にあたり、ユーザーが当社に対して負っている債務がある場合、ユーザーは当然に期限の利益を失い、直ちにすべての債務を履行しなければなりません。',
            '退会後の登録情報の取り扱いは、プライバシーポリシーの定めによります。',
          ],
        },
      ],
    },
    {
      h: '第15条（知的財産権）',
      body: [
        {
          ol: [
            '本サービスに関する著作権その他の知的財産権は、当社または正当な権利者に帰属します。',
            'ユーザーが本サービスに登録した情報（登録情報）の権利は、ユーザーに帰属します。当社は、本サービスの提供に必要な範囲でのみこれを利用します。',
            '当社は、ユーザーを識別できない形に加工した統計情報を、本サービスの改善その他の目的で利用できるものとします。',
          ],
        },
      ],
    },
    {
      h: '第16条（保証の否認および免責事項）',
      body: [
        {
          ol: [
            '当社は、本サービスがユーザーの特定の目的に適合すること、期待する機能・正確性・有用性を有すること、不具合が生じないことを保証しません。',
            '当社は、本サービスに関してユーザーに生じた損害について、当社に故意または重過失がある場合を除き、一切の責任を負いません。',
            '前項の定めにかかわらず、当社に故意または重過失がない場合であっても、消費者契約法の適用その他の理由により当社が責任を負う場合、当社の賠償責任は、当該損害が発生した月にユーザーが当社に支払った利用料金の額を上限とします。',
            '当社は、本サービスに起因してユーザーと他のユーザーまたは第三者との間で生じた紛争について、一切の責任を負いません。',
            '当社は、本サービスが提供する情報（AI機能の出力を含む）が、税務・会計・法務上の助言に該当しないことを明示します。',
          ],
        },
      ],
    },
    {
      h: '第17条（サービス内容の変更・終了）',
      body: [
        {
          ol: [
            '当社は、ユーザーへの事前の通知をもって、本サービスの内容を変更し、または本サービスの提供を終了することができます。',
            '本サービスの提供を終了する場合、当社は3ヶ月前までにユーザーに通知します。',
            '本サービスの提供終了時、Proプランの未経過期間分の利用料金は、日割りにて返金します。',
            '当社は、本条によりユーザーに生じた損害について、前項の返金を除き、責任を負いません。',
          ],
        },
      ],
    },
    {
      h: '第18条（利用規約の変更）',
      body: [
        {
          ol: [
            '当社は、必要と判断した場合、ユーザーに通知することなく本規約を変更することができます。',
            'ユーザーの権利義務に重大な影響を及ぼす変更を行う場合、当社は変更内容と効力発生日を、効力発生日の30日前までに本サービス上に掲示します。',
            '変更後の本規約は、本サービス上に掲示した時点（前項の場合は効力発生日）から効力を生じます。',
          ],
        },
      ],
    },
    {
      h: '第19条（通知または連絡）',
      body: [
        'ユーザーと当社との間の通知または連絡は、当社の定める方法により行うものとします。当社は、ユーザーが登録したメールアドレスへの送信をもって、通知が到達したものとみなします。',
      ],
    },
    {
      h: '第20条（権利義務の譲渡の禁止）',
      body: [
        'ユーザーは、当社の書面による事前の承諾なく、本規約上の地位または権利義務を第三者に譲渡・承継させることはできません。',
      ],
    },
    {
      h: '第21条（分離可能性）',
      body: [
        '本規約のいずれかの条項が無効または執行不能と判断された場合であっても、本規約のその他の条項は、引き続き完全に効力を有します。',
      ],
    },
    {
      h: '第22条（準拠法・裁判管轄）',
      body: [
        {
          ol: [
            '本規約の解釈にあたっては、日本法を準拠法とします。',
            `本サービスに関して紛争が生じた場合、${BIZ.court}を第一審の専属的合意管轄裁判所とします。`,
          ],
        },
      ],
    },
  ],
};

// ------------------------------------------------------------
// プライバシーポリシー
// ------------------------------------------------------------
const privacy = {
  title: 'プライバシーポリシー',
  updated: BIZ.effectiveDate,
  intro: `${BIZ.name}（以下「当社」）は、当社が提供するサービス「Totonoee」および「Totonoee Manager」（以下あわせて「本サービス」）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」）を定めます。`,
  sections: [
    {
      h: '第1条（取得する情報）',
      body: [
        '（1）ユーザーが入力・登録する情報',
        {
          table: {
            head: ['分類', '具体例'],
            rows: [
              ['アカウント情報', 'メールアドレス、パスワード（暗号化して保存）、表示名'],
              ['事業者情報', '屋号、住所、電話番号、適格請求書発行事業者登録番号、振込先口座情報、署名、電子印'],
              ['案件情報', '案件名、金額、期間、稼働日、ステータス、メモ'],
              ['取引先情報', 'クライアント名'],
              ['書類情報', '見積書・注文書・請求書の内容、金額、支払期日'],
              ['経費情報', '金額、カテゴリ、メモ、領収書の画像'],
            ],
          },
        },
        {
          note: 'クライアント名など、取引先に関する情報を入力される場合、それが第三者の個人情報にあたることがあります。ユーザーは、自らの責任においてこれを入力するものとします。',
        },
        '（2）自動的に取得する情報',
        {
          ul: [
            'IPアドレス',
            'ブラウザの種類・バージョン',
            'アクセス日時',
            '端末に保存される情報（ログインセッション、テーマ設定、オンボーディングの表示状態）',
          ],
        },
        '（3）決済に関する情報',
        'Proプランをご利用の場合、決済に必要な情報は Stripe, Inc. が直接取得・管理します。当社はクレジットカード番号・セキュリティコードを取得しません。当社が保持するのは、Stripeが発行する顧客ID・サブスクリプションID・契約状態のみです。',
      ],
    },
    {
      h: '第2条（利用目的）',
      body: [
        '当社は、取得した情報を以下の目的で利用します。',
        {
          ol: [
            '本サービスの提供・運営・維持のため',
            'ユーザーの本人確認・認証のため',
            'Proプランの利用料金の請求・決済のため',
            'ユーザーからのお問い合わせに対応するため',
            '本サービスの不具合の調査・改善のため',
            '利用規約に違反する行為に対応するため',
            '本サービスに関する重要なお知らせを通知するため',
            '個人を識別できない形に加工した統計データを作成し、本サービスの改善に利用するため',
          ],
        },
        '当社は、ユーザーの登録情報を広告配信のために利用しません。また、第三者に販売しません。',
      ],
    },
    {
      h: '第3条（AI機能における情報の取扱い・外国への提供）',
      body: [
        '本サービスのAI機能（AI見積もり提案、AI請求メール生成、AI収支コーチ、AIチャット）は、Anthropic PBC（米国）が提供する大規模言語モデルAPIを利用しています。',
        'AI機能を利用した場合、その機能に応じて以下の情報が Anthropic PBC のサーバー（米国）に送信されます。',
        {
          table: {
            head: ['機能', '送信される情報'],
            rows: [
              ['AI見積もり提案', '案件名、概要、納期、工数、役割、単価レンジ'],
              ['AI請求メール生成', 'クライアント名、担当者名、案件名、請求金額、支払期限、振込先、送信者名'],
              ['AI収支コーチ', '月次の収入・経費・利益・未請求額、カテゴリ別経費'],
              ['AIチャット', 'ユーザーが入力したメッセージ'],
            ],
          },
        },
        '外国にある第三者への提供について（個人情報保護法第28条）',
        {
          table: {
            head: ['項目', '内容'],
            rows: [
              ['移転先', 'Anthropic PBC'],
              ['所在国', 'アメリカ合衆国'],
              [
                '当該国の個人情報保護制度',
                '米国には日本の個人情報保護法に相当する包括的な連邦法は存在せず、分野別の法律および州法により規律されています',
              ],
              [
                '移転先が講じる保護措置',
                '同社は、事業者向けAPIについて、送信されたデータをモデルの学習に利用しない旨を定めています。詳細は同社のプライバシーポリシーをご確認ください',
              ],
            ],
          },
        },
        {
          note: 'AI機能をご利用にならない場合、上記の情報が外国に送信されることはありません。AI機能の利用は任意です。',
        },
      ],
    },
    {
      h: '第4条（Totonoee Manager による情報の閲覧＝第三者提供）',
      body: [
        'Totonoee Manager を利用する管理者（発注者）は、フリーランサー本人の承認を得た場合に限り、当該フリーランサーの情報を閲覧できます。',
        '承認がなければ、一切閲覧できません。',
        {
          ol: [
            '管理者は、フリーランサーに対し連携の招待を送ることができます。この時点では、管理者はフリーランサーのいかなる情報も閲覧できません。',
            'フリーランサー本人が招待を承認して初めて、連携が成立します。',
            '案件情報は、初期状態では管理者に公開されません。フリーランサーが案件ごとに公開設定を行った場合にのみ、当該案件が管理者に表示されます。',
            'フリーランサーは、いつでも公開設定を解除し、または連携そのものを解除できます。',
          ],
        },
        '承認後に管理者が閲覧できる情報',
        {
          ul: [
            '表示名、事業者情報',
            '公開設定された案件のみの情報（案件名、金額、期間、稼働日、ステータス）',
            '経費情報',
          ],
        },
        '管理者に閲覧されない情報',
        {
          ul: ['公開設定していない案件', 'パスワード', 'Proプランの契約情報・決済情報'],
        },
        {
          note: '管理者は、閲覧した情報を編集・削除することはできません（閲覧のみ）。',
        },
      ],
    },
    {
      h: '第5条（第三者提供）',
      body: [
        '当社は、以下の場合を除き、あらかじめユーザーの同意を得ることなく、個人情報を第三者に提供しません。',
        {
          ol: [
            '法令に基づく場合',
            '人の生命、身体または財産の保護のために必要があり、本人の同意を得ることが困難であるとき',
            '公衆衛生の向上または児童の健全な育成の推進のために特に必要があり、本人の同意を得ることが困難であるとき',
            '国の機関等が法令の定める事務を遂行することに対して協力する必要があり、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき',
          ],
        },
      ],
    },
    {
      h: '第6条（業務委託先）',
      body: [
        '当社は、本サービスの提供のため、以下の事業者に個人情報の取扱いを委託しています。',
        {
          table: {
            head: ['委託先', '所在国', '委託する業務'],
            rows: [
              ['Supabase, Inc.', '米国', 'データベース・認証基盤・ファイル保管'],
              ['Vercel, Inc.', '米国', 'アプリケーションのホスティング'],
              ['Stripe, Inc.', '米国', '決済処理'],
              ['Anthropic PBC', '米国', 'AI機能（第3条参照）'],
              ['Resend, Inc.', '米国', 'メール送信（案件依頼の通知）'],
            ],
          },
        },
        '当社は、これらの委託先に対し、個人情報の適切な取扱いを求め、必要かつ適切な監督を行います。',
        {
          note: '上記委託先はいずれも外国に所在するため、個人データは外国に移転されます。本サービスをご利用いただくことで、これに同意いただいたものとみなします。',
        },
      ],
    },
    {
      h: '第7条（Cookie等の利用）',
      body: [
        '本サービスは、ログイン状態の保持および利用環境の記憶のために、ブラウザの保存領域（Cookie、ローカルストレージ）を利用します。',
        '当社は、広告配信・行動追跡を目的としたCookieを使用していません。',
        '保存する主な情報：',
        {
          ul: [
            'ログインセッション（Supabase認証トークン）',
            'テーマ設定（ライト／ダーク）',
            'オンボーディングツアーの表示状態',
            'デモモードの利用状態',
          ],
        },
        'これらを無効化した場合、本サービスが正常に動作しないことがあります。',
      ],
    },
    {
      h: '第8条（個人情報の開示・訂正・削除）',
      body: [
        {
          ol: [
            'ユーザーは、本サービス内の「プロフィール設定」から、登録情報をいつでも閲覧・訂正できます。',
            'ユーザーは、当社に対し、保有個人データの開示・訂正・追加・削除・利用停止を請求できます。',
            `前項の請求は、${BIZ.email} 宛にご連絡ください。本人であることを確認できた場合に限り、法令に従って対応します。`,
            '当社は、開示請求について、手数料を申し受けません。',
          ],
        },
      ],
    },
    {
      h: '第9条（保有期間・退会時の取扱い）',
      body: [
        {
          ol: [
            '当社は、利用目的の達成に必要な期間、個人情報を保有します。',
            'ユーザーが退会した場合、当社は登録情報を退会から30日以内に削除します。',
            '前項にかかわらず、法令により保存が義務付けられている情報（決済に関する記録等）については、当該法令に定める期間、保存します。',
            'Proプランを解約しFreeプランへ移行した場合、登録情報は削除されません。',
          ],
        },
      ],
    },
    {
      h: '第10条（安全管理措置）',
      body: [
        '当社は、個人情報の漏えい、滅失または毀損の防止その他の安全管理のために、以下の措置を講じています。',
        {
          ul: [
            '通信の暗号化（TLS）',
            'パスワードの暗号化保存',
            'データベースにおける行単位のアクセス制御（Row Level Security）による、ユーザー間のデータ分離',
            '認証情報・APIキーのサーバー側での管理（クライアント側に露出させない）',
            'アクセス権限の最小化',
          ],
        },
      ],
    },
    {
      h: '第11条（お子様の情報）',
      body: [
        '本サービスは、事業を営む方を対象としています。当社は、16歳未満の方からの個人情報の取得を意図していません。',
      ],
    },
    {
      h: '第12条（プライバシーポリシーの変更）',
      body: [
        {
          ol: [
            '当社は、必要に応じて本ポリシーを変更することがあります。',
            '変更後の本ポリシーは、本サービス上に掲示した時点から効力を生じます。',
            'ただし、ユーザーの同意が必要な変更を行う場合は、当社所定の方法により同意を取得します。',
          ],
        },
      ],
    },
    {
      h: '第13条（お問い合わせ窓口）',
      body: [
        '本ポリシーに関するお問い合わせ、開示等の請求は、以下までご連絡ください。',
        {
          table: {
            head: ['項目', '内容'],
            rows: [
              ['事業者名', BIZ.name],
              ['個人情報保護管理責任者', BIZ.owner],
              ['住所', BIZ.address],
              ['メールアドレス', BIZ.email],
            ],
          },
        },
      ],
    },
  ],
};

export const LEGAL_DOCS = { tokushoho, terms, privacy };

// ルーティング用のメタ（Legal.js / フッターリンクで共有）
export const LEGAL_LINKS = [
  { key: 'terms', path: '/legal/terms', label: '利用規約' },
  { key: 'privacy', path: '/legal/privacy', label: 'プライバシーポリシー' },
  { key: 'tokushoho', path: '/legal/tokushoho', label: '特定商取引法に基づく表記' },
];
